// @ts-ignore
import { CSSResultGroup, html, TemplateResult } from 'lit';
// @ts-ignore
import { customElement, property } from 'lit/decorators.js';
// @ts-ignore
import componentStyles from './idb-vertical-timeline.css.lit';
// @ts-ignore
import { ClassInfo, classMap } from 'lit/directives/class-map.js';
import {OutlineElement} from "../../base/outline-element/outline-element";
import {SlotController} from "../../controllers/slot-controller";


@customElement('idb-vertical-timeline')
export class IdbVerticalTimeline extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  /* Color Style for the heading text. */
  @property({ type: String, reflect: true, attribute: 'color' })
  color: string;

  render(): TemplateResult {
    const classes = {
      'timeline': true,
      [`idb-color--${this.color || 'default'}`]: true,
    };

    return html`
      <div class="${classMap(classes)}">
        <slot></slot>
        <div class="arrow"></div>
      </div>
    `;
  }
}
